<!-- 首席服务员 -->
<template>
    <div class='cheif_contaniner'>
        <!--左边-->
        <div class="box_f1 box box_v" style="margin-right:10px">
            <left1 class="box box_f1" style="margin-bottom:10px;"></left1>
            <left2 class="box box_f1" style="margin-bottom:10px;"></left2>
            <left3new class="box box_f1"></left3new>
        </div>
        <!--中间-->
        <div class="box_f2 box box_v" style="margin:0 10px">
            <div class="box box_f2 box_v"  style="margin-bottom:20px;">
                <middle1 class="box" style="height:100px;margin-bottom:10px;"></middle1>
                <div class="box_f1" style="position:relative;">
                    <middle2-left class="middle_left" :show="show"></middle2-left>
                    <middle2-right class="middle_right" :show="show"></middle2-right>
                </div>
            </div>
           <div class="box box_f1">
               <middle3-left class="box_f1" style="margin-right:10px"></middle3-left>
               <middle3-right class="box_f1" style="margin-left:10px"></middle3-right>
           </div>
        </div>
        <!--右边-->
        <div class="box_f1 box box_v" style="margin-left:10px">
            <right1 class="box box_f1" style="margin-bottom:10px"></right1>
            <right2 class="box box_f1" style="margin-bottom:10px"></right2>
            <right3 class="box box_f1"></right3>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import left1 from './left1'
import left2 from './left2'
import left3new from './left3new'
import middle1 from './middle1'
import middle2Left from './middle2left'
import middle2Right from './middle2right'
import middle3Left from './middle3left'
import middle3Right from './middle3right'
import right1 from './right1'
import right2 from './right2'
import right3 from './right3'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {left1,left2,left3new,middle1,middle2Left,middle2Right,middle3Right,middle3Left,right3,right2,right1},
    data() {
    //这里存放数据
        return {

        };
    },
    props:{
        show:{
            type:Boolean,
            default:false
        }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.cheif_contaniner{
    width:100%;
    height:100%;
    display: flex;
}
.middle_left{
    position: absolute;
    top:0;
    left:0;
    right:calc(50% + 10px);
    bottom: -10px;
}
.middle_right{
    position: absolute;
    top:0;
    left:calc(50% + 10px);
    right:0;
    bottom: -10px;
}
</style>